


























































import Vue, { VueConstructor } from 'vue';
import { SUGGEST_URL, PROJECT_DISPLAY_NAME } from '@/constants';
import { debounce } from '@/util/util';
import Autocomplete from '@/generic/components/Autocomplete.vue';
import { SEARCH_FIELDS } from '@/searchFields';

export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      searchInput: InstanceType<typeof HTMLInputElement>,
    };
  }
>).extend({

  components: {
    Autocomplete,
  },

  data() {
    return {
      search: '',
      PROJECT_DISPLAY_NAME,
      lastPasted: '',
      searchField: 'lemma',
      SEARCH_FIELDS,
    }
  },

  computed: {
    suggestString: function (): string {
      const el = this.$refs.searchInput;
      const pos = this.search.length;
      const partSearchString = this.search.substr(0, pos);
      const suggestString = partSearchString.lastIndexOf(' ') > 0 ? partSearchString.substr(partSearchString.lastIndexOf(' ') + 1) : partSearchString;
      return suggestString;
    },

    suggestActive: function(): boolean {
      return this.searchField === 'lemma' && this.lastPasted !== this.search;
    },
  },

  watch: {
    $route() {
      this.onRouteChanged();
    },
  },

  mounted() {
    this.updateSearch();
  },

  methods: {

    getPreSuggestString() {
      const el = this.$refs.searchInput;
      const pos = el.selectionEnd && el.selectionEnd > 0 ? el.selectionEnd : this.search.length;
      const partSearchString = this.search.substr(0, pos);
      const preSuggestString = partSearchString.lastIndexOf(' ') > 0 ? partSearchString.substr(0, partSearchString.lastIndexOf(' ') + 1) : '';
      return preSuggestString;
    },

    pasteSuggestion(suggestion: string) {
      const el = this.$refs.searchInput;
      const pos = el.selectionEnd || this.search.length;
      const suggestSearch = this.suggestString;
      this.search = this.getPreSuggestString() + suggestion;
      el.selectionStart = el.selectionEnd = pos - suggestSearch.length + suggestion.length;
      el.focus();
      this.lastPasted = this.search; // don't suggest for this
    },

    onRouteChanged() {
      this.updateSearch();
    },

    updateSearch() {
      if (this.$route.query.q)
        this.search = this.$route.query.q.toString();
    },

    onSubmit() {
      this.$router.push({ name: 'results', query: { q: this.search, in: this.searchField } });
    },
  }

});

